import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagifyModule } from 'ngx-tagify';
import { ManagePrivateSellingComponent } from '../group-links/modals/manage-private-selling/manage-private-selling.component';
import { PaginationModule } from '../layout/pagination/pagination.module';
import { EventsComponent } from './events.component';
import { DeleteErrorComponent } from './modals/delete-error/delete-error.component';
import { DeleteComponent } from './modals/delete/delete.component';
import { EditBulkConfirmComponent } from './modals/edit-bulk-confirm/edit-bulk-confirm.component';
import { EditBulkComponent } from './modals/edit-bulk/edit-bulk.component';
import { EditComponent } from './modals/edit/edit.component';
import { ViewComponent } from './modals/view/view.component';
@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    ReactiveFormsModule,
    TagifyModule,
    EventsComponent,
    ViewComponent,
    EditComponent,
    DeleteComponent,
    DeleteErrorComponent,
    EditBulkComponent,
    EditBulkConfirmComponent,
    ManagePrivateSellingComponent,
  ],
  exports: [EventsComponent],
})
export class EventsModule {}
